export default "__VITE_ASSET__DZf25JDr__"